import React from 'react';

import type { IconProps } from '../Icon.types';

export const DotsVerticalDisabledIcon = ({
  width,
  height,
  color,
}: IconProps) => {
  return (
    <svg viewBox="0 0 24 24" width={width} height={height}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9 8C10.1046 8 11 7.10457 11 6C11 4.89543 10.1046 4 9 4C7.89543 4 7 4.89543 7 6C7 7.10457 7.89543 8 9 8ZM9 14C10.1046 14 11 13.1046 11 12C11 10.8954 10.1046 10 9 10C7.89543 10 7 10.8954 7 12C7 13.1046 7.89543 14 9 14ZM11 18C11 19.1046 10.1046 20 9 20C7.89543 20 7 19.1046 7 18C7 16.8954 7.89543 16 9 16C10.1046 16 11 16.8954 11 18ZM15 8C16.1046 8 17 7.10457 17 6C17 4.89543 16.1046 4 15 4C13.8954 4 13 4.89543 13 6C13 7.10457 13.8954 8 15 8Z"
        fill={color}
      />
      <path
        d="M17.5 11C19.1569 11 20.5 12.3365 20.5 13.992V15L21.2481 15.001C21.6634 15.001 22 15.3408 22 15.7609V20.2401C22 20.6598 21.6582 21 21.2481 21H13.7519C13.3366 21 13 20.6602 13 20.2401V15.7609C13 15.3412 13.3418 15.001 13.7519 15.001L14.5 15V14.0012C14.5 12.4029 15.7521 11.0964 17.3241 11.0051L17.5 11ZM17.5 12.5L17.3546 12.5069C16.5898 12.5796 16 13.2203 16 14V15.001H19V14C19 13.1658 18.3284 12.5 17.5 12.5Z"
        fill={color}
      />
    </svg>
  );
};
